import React, { Fragment, useEffect } from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "styled-components";
import { BrowserRouter as Router, Route } from "react-router-dom";
import {
  theme,
  materialThemeProviderOptions,
  MainMenu,
  grommetTheme
} from "./theme";
import { Reset } from "styled-reset";
import { ROUTES } from "./ROUTES";
import Pic from "./assets/eg1.jpg";
import { Footer } from "./Components/Footer/Footer";
import { ThemeProvider as Mtp } from "rmwc";
import { Portal } from "react-portal";
import { Grommet } from "grommet";

const App = props => {
  return (
    <Fragment>
      <Reset />
      <Grommet theme={grommetTheme}>
        <ThemeProvider theme={theme}>
          <Mtp options={materialThemeProviderOptions}>
            <Router>
              <Fragment>
                <MainMenu routes={ROUTES} />
                {ROUTES.map(r => (
                  <Route
                    exact
                    key={r.path}
                    path={r.path}
                    component={r.component}
                  />
                ))}
                <Footer />
              </Fragment>
            </Router>
          </Mtp>
        </ThemeProvider>
      </Grommet>
    </Fragment>
  );
};
ReactDOM.render(<App />, document.getElementById("root"));
